import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addItemToCart, removeItemFromCart } from 'reducers/cartReducer';
import { getPropertyDocuments } from 'utils/propertyDocuments';
import Spinner from 'components/Spinner';

import './RequestDocuments.css';

function RequestDocuments() {
	const [selectedCategory, setSelectedCategory] = useState('Property Records & Documentation');
	const [searchTerm] = useState('');

	const dispatch = useDispatch();
	const {
		propertyId,
		address,
		isLoading,
		documents,
		cartItems,
	} = useSelector(state => ({
		propertyId: state.property.propertyData?.id,
		address: state.property.propertyData?.address,
		isLoading: state.property.isLoading,
		documents: getPropertyDocuments(state.property.propertyData),
		cartItems: state.cart.items,
	}));

	const categories = [
		'Property Records & Documentation',
		'Structural & Construction',
		'Fire',
		'Mechanical, Plumbing & Fuel',
		'Energy, Environment & Health',
		'Housing, Tenant & HPD',
		'Special Inspections & Progress',
		'Other / General Compliance',
	];

	const selectedDocs = documents[selectedCategory] || [];
	const filteredDocs = selectedDocs.filter(doc =>
		doc.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const addToCart = (documentName) => {
		dispatch(addItemToCart({ address, documentName, propertyId }));
	};

	const removeFromCart = (documentName) => {
		dispatch(removeItemFromCart(address, documentName));
	};

	// Helper function to check if document is in cart
	const isDocumentInCart = (documentName) => {
		return cartItems.some(item => item.address === address && item.documentName === documentName);
	};

	return (
		<div className="rd-request-documents">
			<div className="building-info-card-header">
				<h2 className="building-info-card-title me-3">Documents</h2>
			</div>

			{/* Two panel content area */}
			<div className="rd-overview-data-sets-card-vertical-content">
				{/* Left panel: Categories - Fixed with internal scroll */}
				<div className="rd-overview-data-sets-card-vertical-list-wrapper">
					<div className="documents-categories-list">
						{categories.map((category) => (
							<div
								key={category}
								className={`documents-category-item ${selectedCategory === category ? 'is-selected' : ''}`}
								onClick={() => setSelectedCategory(category)}
								role="button"
								tabIndex={0}
								onKeyDown={(e) => {
									if (e.key === 'Enter') setSelectedCategory(category);
								}}
							>
								{category}
							</div>
						))}
					</div>
				</div>

				{/* Right panel: Documents with search */}
				<div className="rd-overview-data-sets-card-vertical-table-wrapper">
					

					<div className="documents-content-panel">
						<h5 className="documents-category-title">{selectedCategory}</h5>
						{isLoading ? (
							<Spinner />
						) : (
							<div className="documents-list-table">
								{filteredDocs.length > 0 ? (
									filteredDocs.map(documentName => {
										const inCart = isDocumentInCart(documentName);
										return (
											<div key={documentName} className="document-item-row">
												<span className="document-name">{documentName}</span>
												<button
													className={`btn btn-sm document-request-btn ${inCart ? 'is-in-cart' : ''}`}
													onClick={() => inCart ? removeFromCart(documentName) : addToCart(documentName)}
												>
													{inCart ? 'Remove from cart' : 'Request'}
												</button>
											</div>
										);
									})
								) : (
									<p className="no-documents">No documents found in this category.</p>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default RequestDocuments;
